import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";
import {setLocalStorage, getLocalStorage} from "@js/helpers.ts";
import {useMenuStore} from "@js/store/MenuStore.js";
import {checkDocument} from "@js/helpers.ts";

const getLikedIdsFromCookie = () => {
    if (!checkDocument()) return []

    const likes = getLocalStorage('likedIds');
    if (likes) {
        try {
            return JSON.parse(likes);
        } catch (e) {
            console.error('Не удалось распарсить likedIds из cookie', e);
            return [];
        }
    }

    return [];
}

export const useLikeStore = defineStore('likeStore', {
    state: () => ({
        likedIds: getLikedIdsFromCookie(),
        products: [],
        loading_products: true,
    }),
    actions: {
        getLikes() {
            const likes = getLocalStorage('likedIds');
            if (likes) {
                try {
                    this.likedIds = JSON.parse(likes);
                } catch (e) {
                    console.error('Не удалось распарсить likedIds из cookie', e);
                    this.likedIds = [];
                }
            }

            return this.likedIds
        },
        toggleLike(productId) {
            const themeStore = useThemeStore();

            if (this.isLiked(productId)) {
                this.likedIds = this.likedIds.filter(id => id !== productId);
                themeStore.addToast("Убрано из избранных", "success");
            } else {
                this.likedIds.push(productId);
                themeStore.addToast("Добавлено в избранное", "success", {
                    route_name: 'likedProducts',
                }, 5000);
                const menuStore = useMenuStore()
                menuStore.triggerCatalogButtonPing('bg-red-600')
            }

            setLocalStorage('likedIds', JSON.stringify(this.likedIds), 525600); //На год
        },
        isLiked(productId) {
            return this.likedIds.includes(productId);
        },
        getLikedProductsData() {
            if (this.likedIds.length) {
                this.loading_products = true
                axios.post('/axios/get-products-by-ids', {
                    ids: this.likedIds,
                }).then(response => {
                    this.products = response.data.products ?? [];
                    this.loading_products = false;
                }).catch(error => {
                    this.loading_products = false;
                });
            } else {
                this.loading_products = false;
            }
        },
    }
});
